import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {CustomerDiscountGroup, CustomerPromo,} from "../../../../redux/actions/Modules.Action";
import ApiConnect from "../../../../Utils/ApiConnect";
import DeletePop from "../../../Components/DeletePop";

class index extends Component {
  constructor(props) {
    super(props);
this.state = {
      showModal: false,
      triggerModal: false,
      selectedId: false,
      btnDisable: false,
      formError: false,
      filterText: "",
    };
    this.columns = [
      {
        name: "Promo Title",
        selector: row => row.name,
      },
      {
        name: "Promo Code",
        selector: row => row.code,
      },
      {
        name: "Promo Limit",
        selector: row => row.limit,
      },
      {
        name: "Total Clamed",
        selector: row => row.total_clamed,
      },
      {
        name: "Last Update",
        selector: row => row.last_used,
      },
      {
        name: "Last Invoice",
        selector: row => row.last_invoice,
      },
      {
        name: "Valid till",
        selector: row => row.valid,
      },
      {
        name: "Action",
        selector: row => row.action,
        className: "table-actions",
        width: "150px",
        sortable: false,
        cell: (row) => {
          return (
            <React.Fragment>
              <button
                className="table-action btn btn-square btn-pure hover-danger"
                onClick={() =>
                  this.setState({ selectedId: row.code, triggerModal: true })
                }
              >
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  componentDidMount() {
    this.fetchPromo();
    this.fetchDiscount();
  }
  fetchPromo = () => {
    ApiConnect.get("/Members/Information/PromoCode")
      .then((response) => {
        this.props.CustomerPromo(response.data);
      })
      .catch((error) => console.log(error));
  };
  fetchDiscount = () => {
    ApiConnect.get("/Members/Information/DiscountGroup")
      .then((response) => {
        this.props.CustomerDiscountGroup(response.data);
      })
      .catch((error) => console.log(error));
  };
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdata = new FormData();
    Fdata.append("name", this.state.name);
    Fdata.append("discount", this.state.group);
    Fdata.append("valid", this.state.valid);
    Fdata.append("code", this.state.code);
    ApiConnect({
      method: "post",
      url: "/Members/Information/NewPromo",
      data: Fdata,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            showModal: false,
            triggerModal: false,
            selectedId: false,
            formError: false,
            name: "",
            group: "",
            valid: "",
            code: "",
          });
          this.fetchPromos();
        } else if (response.data.status) {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  };
  SettriggerModal = () => {
    this.setState({ selectedId: false, triggerModal: false });
  };
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Promo Codes</strong>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  onChange={e => this.setState({ filterText: e.target.value })}
                />
              </div>
              <DataTable
                className="table table-separated"
                keyField="id"
                columns={this.columns}
                data={this.props.Promo.filter(item =>
                  Object.values(item).some(val =>
                    String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
                  )
                )}
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                paginationPerPage={10}
                customStyles={this.customStyles}
                filter
                exportable
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">New Promo</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span>×</span>
                </button>
              </Modal.Header>
              <form onSubmit={(e) => this.handleSubmit(e)}>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Promo Title</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        onChange={(e) => this.handleChange(e)}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Discount Group</label>
                      <select
                        className="form-control"
                        name="group"
                        onChange={(e) => this.handleChange(e)}
                      >
                        <option>Select Group</option>
                        {this.props.Discount.map((group, index) => (
                          <option value={group.id} key={`${group}${index}`}>
                            {group.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Code</label>
                      <input
                        onChange={(e) => this.handleChange(e)}
                        type="text"
                        className="form-control"
                        name="code"
                        required="required"
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Valid till</label>
                      <label className="col-12">
                        <input
                          onChange={(e) => this.handleChange(e)}
                          type="date"
                          className="form-control"
                          name="valid"
                          required="required"
                        />
                      </label>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button type="submit" className="btn btn-success">
                    Create
                  </button>
                </Modal.Footer>
              </form>
            </Modal.Dialog>
          </Modal>
          <DeletePop
            trigger={this.state.triggerModal}
            delUrl={`/Members/Information/DeletePromo?id=${this.state.selectedId}`}
            hideTrigger={this.SettriggerModal}
            fallAction={this.fetchPromo}
          />
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    Promo: state.Customer.Promo,
    Discount: state.Customer.Discount,
  }),
  { CustomerPromo, CustomerDiscountGroup }
)(index);
